module.exports = __webpack_public_path__ + "img/nav-profile.14de8423.svg";